import React, {useEffect, useState} from "react";
import {ItemPropertySelect} from "./ItemPropertySelect";
import {GridActionsCellItem, useGridApiRef} from '@mui/x-data-grid';
import {GridDiv, StyledDataGrid, StyledGridOverlay} from "./styles";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import {Box} from "@mui/material";
import {NoRowsSvg} from "./NoRowsSvg";
import axios from "axios";
import axiosConfig from "../../../../../utils/axiosConfig";
import messageCodes from "../../../../../utils/messageCodes";
import {connect} from "react-redux";
import {showToastForBackend, showToastForFrontend} from "../../../../../actions/toastActions";
import uniqueId from "lodash/uniqueId";

const CustomNoRowsOverlay = () => {
    return (
        <StyledGridOverlay>
            <NoRowsSvg/>
            <Box sx={{m: 1}}>No Rows</Box>
        </StyledGridOverlay>
    );
}

export const EditorialEntitiesList = (props) => {
    const {label, onSelect, items, state, action, actionType, onPaginationModelChange, getItems} = props;
    const addDoneIcon = <AddIcon/>;
    const removeIcon = <CloseIcon/>;
    const apiRef = useGridApiRef();
    const [visibleColumns, setVisibleColumns] = useState({});
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const fetchRowsCount = async () => {
        setIsLoading(true);
        let requestBody = {
            spelFilter: `map['${state.searchedOption}'] != null && map['${state.searchedOption}'].?[#this == '${state.searchText}'].length>0`
        }
        await axios.post(props.properties.databaseUrl + "/items/count", requestBody, axiosConfig())
            .then((response) => {
                setRowCount(response.data);
            })
            .catch(error => {
                if (error.response) {
                    props.showToastForBackend(error.response.data);
                } else {
                    props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                }
            }).finally(() => {
                setIsLoading(false);
            });
    }

    useEffect(() => {
        if (props.properties) {
            fetchRowsCount()
        }
    }, [items])

    useEffect(() => {
        if (getItems) {
            getItems()
        }
    }, [state.paginationModel])

    const getRowId = (row) => {
        return row.itemId !== undefined ? row.itemId : row.entityId || uniqueId();
    }

    const isRowInactive = (params) => {
        if (params.row.map?.['__active'] !== undefined) {
            return params.row.map['__active'][0] === '0' ? 'inactive' : '';
        } else {
            return '';
        }
    }

    const getSearchedPropField = (params) => {
        if (state.showSearchedProperty === "") {
            return "";
        }
        if (state.showSearchedProperty === "itemId") {
            return params.row.itemId !== undefined ? params.row.itemId : params.row.entityId;
        } else {
            if (params.row.map !== undefined) {
                return params.row?.map[state.showSearchedProperty];
            } else {
                return params.row[state.searchedOption];
            }
        }
    }

    const handleClick = (params) => {
        if (actionType === "add" && (
            state.selectedItems.find(item => item.itemId === params.row.itemId) === undefined
            || state.selectedItems.find(item => item.itemId === params.row.entityId) === undefined)
        ) {
            action(params.row);
        }
        if (actionType === "remove") {
            action(params.row);
        }
    }

    const onFilterModelChange = (filterModel) => {
        if (filterModel && filterModel.items && filterModel.items.length > 0) {
            const {field, value} = filterModel.items[0];
            if (field === "entityId") {
                if (value !== undefined) {
                    setIsLoading(true);
                    getItems();
                    setIsLoading(false);
                    localStorage.setItem('itemFilterSettings', JSON.stringify({items: filterModel.items}));
                } else {
                    localStorage.setItem('itemFilterSettings', JSON.stringify({items: []}));
                }
            }
        }
    }

    const columns = [
        {
            field: 'entityId', headerName: 'Item Id',
            flex: 1,
            minWidth: 150,
        },
        {
            field: 'searchedProperty',
            headerName: `${state.showSearchedProperty || 'Searched property'}`,
            width: 330,
            valueGetter: (params) => `${getSearchedPropField(params)}`,
        },
        {
            disableColumnMenu: true,
            field: 'selectedProperty', headerName: 'Selected property',
            valueOptions: state.searchOptions,
            width: 330,
            sortable: false,
            valueGetter: (params) => {
                if (state.selectedOption === "itemId") {
                    return params.row.itemId !== undefined ? params.row.itemId : params.row.entityId;
                } else {
                    return params.row.map ? params.row.map[state.selectedOption] : params.row[state.selectedOption];
                }
            },
            renderHeader: (params) => (
                <ItemPropertySelect
                    onSelect={onSelect}
                    selectValue={state.selectedOption}
                    selectArray={state.searchOptions}
                />
            ),
        },
        {
            field: 'actions',
            type: 'actions',
            width: 80,
            getActions: (params, key) => [
                <GridActionsCellItem
                    icon={actionType === "add" ? addDoneIcon : removeIcon}
                    label="Action"
                    key={key}
                    onClick={() => handleClick(params)}
                />,
            ],
        },];

    useEffect(() => {
        if (columns.length > 0) {
            const filterModel1 = localStorage.getItem('itemFilterSettings') ? JSON.parse(localStorage.getItem('itemFilterSettings')) : {items: []};
            apiRef.current.setFilterModel(filterModel1);
        }
    }, [apiRef, columns]);

    return (
        <div className="filter-group">
            <div className="filter-group-header">
                <label className="checkbox-wrapper">{label}</label>
            </div>
            {items !== undefined && items[0] !== {} &&
                <GridDiv>
                    <StyledDataGrid
                        slots={{
                            noRowsOverlay: CustomNoRowsOverlay,
                        }}
                        autoHeight
                        rows={items}
                        columns={columns}
                        getRowId={getRowId}
                        getRowClassName={(params) => isRowInactive(params)}
                        initialState={{
                            pagination: {
                                paginationModel: {page: 0, pageSize: 5},
                            },
                        }}
                        pageSizeOptions={[5, 10]}
                        onPaginationModelChange={onPaginationModelChange}
                        filterMode="server"
                        paginationMode="server"
                        onFilterModelChange={onFilterModelChange}
                        apiRef={apiRef}
                        disableSelectionOnClick
                        columnVisibilityModel={visibleColumns}
                        rowCount={rowCount}
                        loading={isLoading}
                    />
                </GridDiv>
            }
        </div>
    )
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
    }
}

export default connect(mapStateToProps, {showToastForBackend, showToastForFrontend})(EditorialEntitiesList);